import React from 'react'
import { Route, Switch } from 'react-router-dom'

import FactsetTable from 'pages/Factset/FactsetTable'
import DS1Person from 'pages/Ds1People/DS1Person'
import Securities from 'pages/Factset/Securities'
import OrganizationEdit from 'pages/Factset/OrganizationEdit'
function FactsetRouter() {
  return (
    <Switch>
      <Route exact path="/factset/people" component={() => <FactsetTable entity="people" />} />
      <Route exact path="/factset/people/:id" component={DS1Person} />
      <Route
        exact
        path="/factset/organizations"
        component={() => <FactsetTable entity="organizations" />}
      />
      <Route exact path="/factset/organizations/:id/edit" component={OrganizationEdit} />
      <Route exact path="/factset/securities" component={Securities} />
    </Switch>
  )
}

export default FactsetRouter
